import { Timestamp } from '@bufbuild/protobuf';

export const getDateTime = (d: Timestamp) => {
  const date = new Date(d.toDate());

  return new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
  }).format(date);
};

export const getDate = (d: Timestamp) => {
  const date = new Date(d.toDate());

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Return the formatted string
  return `${month} ${day} ${year}`;
};

export const getTime = (d: Timestamp) => {
  const date = new Date(d.toDate());

  return new Intl.DateTimeFormat('en-GB', {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true,
  })
    .format(date)
    .replace('am', 'AM')
    .replace('pm', 'PM');
};
